import React, { Component } from 'react';
import '../../../resources/AdminStandardPage.css';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import ReactPaginate from 'react-paginate';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { electionsService } from '../../../services/ElectionsService';

class Elections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newElectionDocument: {
        title: '',
        document: '',
        add_date: '',
        year: 2020
      },
      existingElectionsDocument: [],
      deleteElectionDocument: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }
  componentWillMount() {
    electionsService
      .getAll()
      .then(response => {
        this.setElectionDocumentState(response);
      })
      .catch(error => {
        console.log(error);
      });
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  setElectionDocumentState = response => {
    let existingElectionsDocument = this.state.existingElectionsDocument;
    existingElectionsDocument = response.data.elections;

    let pagination = { ...this.state.pagination };
    pagination = response.data.pagination;

    this.setState({
      existingElectionsDocument
    });
    this.setState({
      pagination
    });
  };

  handlePageClick = selectedPage => {
    electionsService
      .getAll(selectedPage, selectedPage + 1)
      .then(jsonResponse => {
        this.setElectionDocumentState(jsonResponse);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateField = event => {
    const field = event.target.name;
    let newElectionDocument = { ...this.state.newElectionDocument };
    newElectionDocument[field] = event.target.value;
    this.setState({
      newElectionDocument
    });
  };

  resetForm = () => {
    let newElectionDocument = { ...this.state.newElectionDocument };
    newElectionDocument = {
      title: '',
      document: '',
      add_date: ''
    };
    this.setState({ newElectionDocument });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    electionsService
      .createOrUpdate(this.state.newElectionDocument)
      .then(response => {
        this.resetForm();

        let existingElectionsDocument = this.state.existingElectionsDocument;

        let index = existingElectionsDocument.findIndex(
          existingElectionsDocument =>
            existingElectionsDocument.id === response.id
        );

        if (index !== -1) {
          existingElectionsDocument[index] = response;
        } else {
          existingElectionsDocument.push(response);
        }

        this.setState({
          existingElectionsDocument
        });

        this._notificationSystem.addNotification({
          message: `Documentul a fost ${
            this.state.publicInterestDocument.id ? 'editat' : 'adaugat'
          } cu success.`,
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la adaugare, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  onDropDocument = documents => {
    let newElectionDocument = { ...this.state.newElectionDocument };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newElectionDocument.document = documents[0];

      self.setState({ newElectionDocument });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newElectionDocument = { ...this.state.newElectionDocument };
    newElectionDocument.document = null;

    this.setState({ newElectionDocument });
    this.setState({ disabledDocument: false });
  };

  openDeleteDialog = id => {
    let deleteElectionDocument = { ...this.state.deleteElectionDocument };
    deleteElectionDocument = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteElectionDocument });
  };

  closeDeleteDialog = () => {
    let deleteElectionDocument = { ...this.state.deleteElectionDocument };
    deleteElectionDocument = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteElectionDocument });
  };

  setElectionDocumentForEdit = electionDocument => {
    let newElectionDocument = { ...this.state.newElectionDocument };
    newElectionDocument = Object.assign({}, electionDocument);
    this.setState({ newElectionDocument });

    if (newElectionDocument.document && newElectionDocument.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  handleDelete = () => {
    electionsService
      .deleteElectionDocument(this.state.deleteElectionDocument.deleteId)
      .then(() => {
        let existingElectionsDocument = this.state.existingElectionsDocument.slice();
        existingElectionsDocument = existingElectionsDocument.filter(
          piDocument =>
            piDocument.id !== this.state.deleteElectionDocument.deleteId
        );
        this.setState({ existingElectionsDocument });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Documentul a fost sters cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la adaugare, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title">
            Documente Alegeri Electorale 2020
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adaugă un document</h2>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu document*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newElectionDocument.title}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată document*
                  </h4>
                  <input
                    className="general-field date-field"
                    type="date"
                    name="add_date"
                    onChange={this.updateField}
                    value={this.state.newElectionDocument.add_date}
                  />
                  <h4 className="label-title label-title-provisions">
                    An Electoral Document
                  </h4>
                  <input
                    className="general-field date-field"
                    type="number"
                    name="year"
                    onChange={this.updateField}
                    value={this.state.newElectionDocument.year}
                  />
                </div>

                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newElectionDocument.document}
                    documentFilename={
                      this.state.newElectionDocument.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newElectionDocument.id
                        ? 'Editează Document'
                        : 'Adaugă Document'}
                    </button>
                  </div>
                  {Object.values(this.state.newElectionDocument) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingElectionsDocument &&
            this.state.existingElectionsDocument.length > 0 && (
              <div className="admin-standard-page__existing-items">
                <div className="card">
                  <div className="existing-items">
                    <h2 className="existing-items__title label-title">
                      Documente Alegeri existente
                    </h2>
                    <div className="existing-items__content">
                      {this.state.existingElectionsDocument.map(document => (
                        <div
                          className="existing-items__content-card"
                          key={document.id}
                        >
                          <div className="card-content provisions-title-content">
                            <h3 className="major-provisions-title">
                              {document.title}
                            </h3>
                          </div>
                          <div className="existing-items__actions-card">
                            <div
                              className="provisions-title-content"
                              onClick={() =>
                                this.setElectionDocumentForEdit(document)
                              }
                            >
                              <h4 className="action-title"> Editează</h4>
                            </div>

                            <div
                              className="provisions-title-content"
                              onClick={() => this.openDeleteDialog(document.id)}
                            >
                              <h4 className="action-title delete-button">
                                {' '}
                                Șterge
                              </h4>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <DeletePUGCertificates
                      opened={this.state.deleteElectionDocument.openedDialog}
                      handleClose={this.closeDeleteDialog}
                      handleDelete={this.handleDelete}
                      headline="Sunteti sigur ca doriti sa stergeti acest document?"
                      aditionalText="Dupa stergere, acest document nu va mai putea fi recuperata."
                    />
                  </div>
                  {this.state.pagination.last_page > 1 && (
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={this.state.pagination.last_page}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  )}
                </div>
              </div>
            )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}
export default Elections;
